import {CA} from '../analytics/Analytics'

export class UIComponentSearchController {
    private readonly input: HTMLInputElement
    private readonly form: HTMLFormElement
    private readonly icon: HTMLImageElement
    readonly onSearchCallback: (searchTerm: string) => void

    constructor(id: string, initialSearchTerm: string, onSearchCallback: (searchTerm: string) => void) {
        this.input = document.getElementById(`component_search_input_${id}`) as HTMLInputElement
        this.form = document.getElementById(`component_search_form_${id}`) as HTMLFormElement
        this.icon = document.getElementById(`component_search_icon_${id}`) as HTMLImageElement

        this.onSearchCallback = onSearchCallback

        this.form.addEventListener('submit', (event: Event) => this.onSubmit(event))
        this.icon.addEventListener('click', (event: Event) => this.onSubmit(event))

        this.input.value = initialSearchTerm

        this.input.addEventListener('keyup', () => {
            if(this.input.value === '') this.onSearchCallback(this.input.value)
        })
    }

    onSubmit(event: Event) {
        event.preventDefault()
        if(event.target == this.icon) CA.sendGoogleAnalyticsEvent(CA.Category.Profile, CA.Label.ClickedProfileSearch)
        this.onSearchCallback(this.input.value)
    }
}
